import { AutogenModelTerminalLookup, AutogenRowTerminalLookup } from "./autogen/AutogenModelTerminalLookup";

export class ModelTerminalLookup extends AutogenModelTerminalLookup<RowTerminalLookup> {
	constructor() {
		super(RowTerminalLookup);
	}
}

export class RowTerminalLookup extends AutogenRowTerminalLookup {
}